import { PALETTE } from '../../common/styles/palette';

export const styles = (theme: any) => {
    return {
        btnReservations: {
            marginTop: 0
        },
        reservationDialog: {
            minWidth: 700,
            minHeight: 500
        },
        reservationDialogHeader: {
            alignItems: 'center'
        },
        tableRow: {
            padding: "5px 0px",
            "&:hover": {
                backgroundColor: "#ececec",
            }
        },
        tableHeader: {
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
            display: 'flex',
            alignItems: 'center',
            padding: "0px",
            borderRadius: "5px 5px 0 0",
        },
        table: {
            display: 'flex',
            alignItems: 'center',
        },
        tableHeaderCell: {
            display: 'flex',
            padding: "2px 5px",
            alignItems: 'center',
            "&.first": {
                borderRadius: "5px 0 0 0",
            },
            "&.last": {
                borderRadius: "0 5px 0 0",
            },
        },
        detailHeaderText: {
            paddingLeft: '0px'
        },
        addReservationDialog: {
            minHeight: 500,
            minWidth: 700
        },
        reservationSlotDetailDialogContent: {
            display: 'flex',
            flexDirection: 'column'
        },
        reservationSlotDetailDialogButtons: {
            display: 'flex',
            justifyContent: 'center'
        },
        reservationSlotDetailDialogButton: {
            margin: 5
        },
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'space-evenly',
            padding: 10
        },
        addTrainerButtonContainer:{
            display: "flex",
            justifyContent: "center",
        },
        trainersContainer: {
            display: 'flex',
            alignItems: 'center'
        },

    }
}